module.exports = __webpack_public_path__ + "static/validation-bb1a0b0edcacb9dbee66510823f8730c.png";